import React from 'react';

const DotNode = ({ data }) => {
  const size = data?.size ?? 10;
  const color = data?.color ?? 'red';

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: size,
        background: color
      }}
    />
  );
};

export default DotNode;
